module.exports = __webpack_public_path__ + "img/rectangle-terminal.faf6442b.svg";